export type SetupIntentClassProps = {
    status: string;
    setup_intent_id: string;
    payment_method_id: string;
    client_secret?: string;
};

export interface SetupIntentInterface {
    status: string;
    setupIntentID: string;
    paymentMethodID: string;
    clientSecret?: string;
}

export default class SetupIntent implements SetupIntentInterface {
    readonly status: string;
    readonly setupIntentID: string;
    readonly paymentMethodID: string;
    readonly clientSecret?: string;

    constructor(props: SetupIntentClassProps) {
        this.status = props.status;
        this.setupIntentID = props.setup_intent_id;
        this.paymentMethodID = props.payment_method_id;
        this.clientSecret = props.client_secret;
    }
}
